import React from "react";
import {
    Form,
    Row,
    Col,
    Card,
    Button,
} from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap, List, Map } from "immutable";
import PropTypes from "prop-types";
import { INPUT_TYPES } from "constants/input-types";
import CompanyLosService from "./../services/company-los-services";
import moment from "moment";
import DocumentViewer from "./../../document-viewer/src/components/index";
import "styles/agreement-tab.css";
import "styles/form.css";
import "styles/document-review.css";
class AgreementForm extends React.PureComponent {

    state = {
        selectedDoc: null,
        templateString: null,
        formFields: null,
        generatedFile: null,
        disablePdfGeneration: true
    };


    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    formFields = new OrderedMap({});

    componentDidUpdate() {
        if(this.state.disablePdfGeneration) {
            this.onChangeValue();
        }
        const master = this.props.form.getFieldValue("master");
        if(master && this.props.agreementMasterList && !this.state.templateString && this.props.agreementDetail) {
            const value = this.props.agreementMasterList && this.props.agreementMasterList.find(_ => _.id === master.id);
            this.onSelectAgreementTemplate(value);
        }
    }

    agreementParser = () => {
        return (
            <Card
                size={"small"}
                title={"Agreement Details"}
                className={"padless-card p-5 mr-10"}
                style={{
                    height: "550px"
                }}
                extra={[
                    <Button size={"small"} className={"mr-5"} key={"refresh"} onClick={this.updateAgreementDetail}>Refresh</Button>,
                    <Button size={"small"} type={"primary"} key={"save"} onClick={(e) => this.onSubmit(e)}>
                        Save
                    </Button>
                ]}
            >
                <div className={cx("form p-10")} style={{
                    height: "500px",
                    overflow: "auto"
                }}>
                    {this.formFields.map((field, fieldName) => {
                        return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                    }).toList().toArray()}
                </div>
            </Card>
        );
    }

    onChangeValue = () => {
        let values = this.props.form.getFieldsValue();
        values = Map(values).map((_, k) => {
            if((_ === null || _ === undefined) && !this.state.disablePdfGeneration) {
                this.setState({
                    disablePdfGeneration: true
                }, () => {
                    return null;
                });
            }
            if(!_) {
                return null;
            }
            return k;
        });
        let isEmpty = values.find((_) => (_ === null || _ === "undefined"));
        if(values.size > 1 && isEmpty === undefined) {
            this.setState({
                disablePdfGeneration: false
            });
        }
    }

    updateAgreementDetail = () => {
        let fieldsObj = this.props.form.getFieldsValue(["master"]);
        fieldsObj = fieldsObj.master && fieldsObj.master.master_data;

        CompanyLosService.getAgreementDetail(this.props.companyId).then(({data}) => {
            const values = data;
            const formDetails = fieldsObj && fieldsObj.map(_ => ({
                label: _.label,
                value: values[_.field],
                field: _.field,
                type: _.type
            }));
            formDetails && formDetails.map((_) => {
                if(_.type === "TABLE_EDITOR") {
                    this.tableValues = {
                        ...this.tableValues,
                        [_.field]: values[_.field]
                    };
                    this.formFields = this.formFields.setIn([_.label, "value"], values[_.field]);
                }
                if(_.label === "Date") {
                    this.props.form.setFieldsValue({
                        "Date": _.value && moment(_.value)
                    });
                } else if(_.label === "Processing Fee") {
                    let val = _.value;
                    if(val && String(val).includes("<br>")) {
                        val = String(val).split("<br>").join("\n");
                    }
                    this.props.form.setFieldsValue({
                        [_.label]: val
                    });
                }
                else {
                    this.props.form.setFieldsValue({
                        [_.label]: _.value ? _.value : null
                    });
                }
            });

            this.generateAgreement(false);
        });
        
    }

    handleSave = (field, rowIndex, record, values) => {
        this.tableValues[field][rowIndex] = {
            ...record,
            ...values
        };
    }

    tableValues = {};

    onSelectAgreementTemplate = (val) => {
        this.setState({
            selectedDoc: val,
            templateString: val.content,
        }, () => {
            this.tableValues = {};
            this.template = val.content;
            const variableRegex = /(\{{.*?\}})/g;
            const fields = this.state.templateString.match(variableRegex);
            this.fieldsForFile = fields;
            let fieldObj = [];
            val.master_data && val.master_data.map(_ => {
                if(_.type === "TABLE_EDITOR") {
                    let value = this.props.agreementDetail && this.props.agreementDetail[_.field];
                    if(this.props.agreementValues && this.props.agreementValues.data && this.props.agreementValues.data[_.label]) {
                        value = this.props.agreementValues.data[_.label];
                    }
                    this.tableValues = {
                        ...this.tableValues,
                        [_.field]: value
                    };
                    fieldObj.push({
                        key: _.label,
                        label: _.label,
                        type: INPUT_TYPES[_.type],
                        columns: _.columns,
                        handleSave: this.handleSave.bind(null, _.field),
                        value: this.tableValues[_.field] 
                    });
                } else {
                    fieldObj.push({
                        key: _.label,
                        label: _.label,
                        type: INPUT_TYPES[_.type],
                        onChange: this.onChangeValue
                    });
                }
            });
            fieldObj = new List(fieldObj);
            this.formFields = fieldObj.toOrderedMap().mapEntries(([,v]) => ([v.key, v]));
            this.setState({
                generatedFile: null
            }, () => {
                this.generateAgreement();
            });
        });
    }

    agreementMasterSelectField = new OrderedMap({
        master: {
            type: INPUT_TYPES.OBJECT_SELECT,
            placeholder: "Select Agreement Template",
            // filterOption: true,
            size: "small",
            labelProp: "name",
            onSelect: this.onSelectAgreementTemplate,
            style: {
                minWidth: "400px",
                maxWidth: "500px"
            },
            rules: [
                {
                    required: true,
                    message: "Field Required"
                }
            ],
            className: "fb-50 form-field"
        }
    });

    renderAgreementSelectForm = () => {
        return (
            <div className={"d-flex"}>
                {this.agreementMasterSelectField
                    .map((field, fieldName) => {
                        if(fieldName === "master") {
                            field.options = this.props.agreementMasterList;
                        }
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    }).toList().toArray()
                }
            </div>
        );
    }

    onEdit = (val) => {
        this.setState({
            templateString: val
        });
    }

    convertBase64ToArray = () => {
        var raw = window.atob(this.state.generatedFile);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for(let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    };

    generatePdf = (_, download, formValues, file) => {
        this.setState({
            generatedFile: _.data && _.data.data,
            templateString: this.template
        }, () => {
            this.template = file;
            if(download) {
                const arrayBuffer = this.convertBase64ToArray();
                var blob = new Blob([arrayBuffer], { type: "application/pdf" });
                var elem = window.document.createElement("a");
                elem.href = window.URL.createObjectURL(blob);
                elem.download = `${formValues["Distributor Name"]}.pdf`;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);

                let formData = new FormData();
                formData.append("master", formValues.master && formValues.master.id);
                formData.append("file", blob);

                this.props.generatePdf(formData);
            }
        });
    }

    generateAgreement = (download=false) => {
        try {
            const file = this.template;
            let formValues = this.props.form.getFieldsValue();
            if(!formValues["Distributor Name"] && this.props.agreementValues && this.props.agreementValues.data) {
                formValues = this.props.agreementValues && this.props.agreementValues.data;
            }
            this.fieldsForFile.map(_ => {
                if(_.includes("+")) {
                    const fieldsArr = _.split("{{")[1].split("}}")[0].split("+").map(_ => _.trim());
                    const fieldResult = fieldsArr.reduce((agg, val) => +(formValues[val] ? formValues[val] : val) + agg, 0);
                    this.template = this.template.replace(_, fieldResult);
                } else if(_.includes("-")) {
                    const fieldsArr = _.split("{{")[1].split("}}")[0].split("-").map(_ => _.trim());
                    let fieldResult = String(fieldsArr.reduce((agg, val) => +(formValues[val] ? formValues[val] : val) - agg, 0));
                    if(fieldResult.includes("-")) {
                        fieldResult = fieldResult.replace("-", "");
                    }
                    this.template = this.template.replace(_, fieldResult);
                } else if(_.includes(".")) {
                    const fieldArr = _.split("{{")[1].split("}}")[0].split(".");
                    const value = formValues[fieldArr[0]] && formValues[fieldArr[0]][fieldArr[1]];
                    if(fieldArr) {
                        this.template = this.template.replace(_, value);
                    } else {
                        this.template = this.template.replace(_, null);
                    }
                } else if(
                    !_.includes("#each") &&
                    !_.includes("/each") &&
                    !_.includes(" loop") &&
                    !_.includes("@index") &&
                    !_.includes("if ") &&
                    !_.includes("/if")
                ) {
                    const field = _.split("{{")[1].split("}}")[0];
                    const regex = new RegExp(_);
                    if(field === "Date") {
                        this.template = this.template.replace(regex, moment(formValues[field]).format("MMM DD, YYYY"));
                    } else if(field === "Processing Fee") {
                        const processingFeeArr = formValues["Processing Fee"] && formValues["Processing Fee"].split("\n");
                        const processingFee = processingFeeArr && processingFeeArr.length && processingFeeArr.map((_, k) => (
                            `<li key=${k}>
                                <p>${_}</p>
                            </li>`
                        )).join("");
                        this.template = this.template.replace(regex, processingFee);
                    } else if(field === "Processing Fees") {
                        const processingFeeArr = formValues["Processing Fees"] && formValues["Processing Fees"].split("\n");
                        const processingFee = processingFeeArr && processingFeeArr.length && processingFeeArr.map((_, k) => (
                            `<li key=${k}>
                                <p>${_}</p>
                            </li>`
                        )).join("");
                        this.template = this.template.replace(regex, processingFee);
                    }
                    else if(field.includes("Lower Range")) {
                        this.template = this.template.replace("{{Lower Range}}", formValues["Lower Range (Retailer T/O)"]);
                    } else if(field.includes("Upper Range")) {
                        this.template = this.template.replace("{{Upper Range}}", formValues["Upper Range (Retailer T/O)"]);
                    } else if(field.includes("Distributor CD period for retailers")) {
                        this.template = this.template.replace("{{Distributor CD period for retailers}}", formValues["Distributor CD period for retailers (Before Progcap)"]);
                    } else if(field === "Profile") {
                        const profile = formValues["Profile"] && formValues["Profile"].split("\n").join("<br />");
                        this.template = this.template.replace(regex, profile);
                    } else if(field === "Credit Remarks") {
                        const credit_remarks = formValues["Credit Remarks"] && formValues["Credit Remarks"].split("\n").join("<br />");
                        this.template = this.template.replace(regex, credit_remarks);
                    } else {
                        this.template = this.template.replace(regex, formValues[field]);
                    }
                } else {
                    this.template = this.template.replace(" loop}}", "}}");
                }
            });
            const processingFeeArr = formValues["Processing Fee"] ? 
                formValues["Processing Fee"].split("\n") : 
                (formValues["Processing Fees"] ?
                    formValues["Processing Fees"].split("\n") :
                    null);
            const processingFee = processingFeeArr && processingFeeArr.length && processingFeeArr.map((_, k) => (
                `<li key=${k}>
                    <p>${_}</p>
                </li>`
            ));
            const data = {
                content: this.template,
                formData: {
                    "Distributor Name": 
                        this.props.agreementDetail && 
                        this.props.agreementDetail.distributor_name,
                    ...formValues,
                    "Processing Fee": processingFee,
                    "Processing Fees": processingFee,
                    "signature_authorities": this.props.agreementDetail && this.props.agreementDetail.signature_authorities,
                    "banking": this.props.agreementDetail && this.props.agreementDetail.banking,
                    "brand_contributions": this.props.agreementDetail && this.props.agreementDetail.brand_contributions,
                    "Lower Range": formValues["Lower Range (Retailer T/O)"],
                    "Upper Range": formValues["Upper Range (Retailer T/O)"],
                    "Profile": formValues["Profile"] && formValues["Profile"].split("\n").join("<br />"),
                    ...this.tableValues
                },
                isBase64: true
            };
            const isCredit = formValues.master && formValues.master.name && formValues.master.name.toLowerCase().includes("credit");
            if(!isCredit) {
                CompanyLosService.generateAgreementPdf(data).then(_ => {
                    this.generatePdf(_, download, formValues, file);
                }).catch(() => {
                    this.setState({
                        generatedFile: null
                    });
                });
            } else {
                CompanyLosService.generateCreditPdf(data).then(_ => {
                    this.generatePdf(_, download, formValues, file);
                }).catch(() => {
                    this.setState({
                        generatedFile: null
                    });
                });
            }
        } catch(error) {
            console.error("error => ", error);
        }
    }

    onSubmit = e => {
        try {
            e.preventDefault();
            this.props.form.validateFields((err, values) => {
                if(!err) {
                    const newValues = {
                        data: {
                            ...values,
                            ...this.tableValues,
                            Date: values.Date && values.Date._isMomentObject ? values.format("YYYY-MM-DD") : values.Date
                        },
                        master: values.master.id,
                        agreement: this.state.templateString,
                    };
                    this.props.onSubmit(newValues);
                }
            });
        } catch(error) {
            console.error("err -> ", error);
        }
    }

    render() {
        return (
            <Form style={FORM_STYLE}>
                <Row>
                    <Col className={"m-05"} span={24}>
                        {this.renderAgreementSelectForm()}
                    </Col>
                    <Col className={"m-05"} span={10}>
                        {this.agreementParser()}
                    </Col>
                    <Col className={"m-05"} span={14}>
                        <Card
                            size={"small"}
                            title={"Agreement Editor"}
                            className={"padless-card p-5 file-viewer"}
                            extra={[
                                <Button key={"preview"} size={"small"} className={"mr-5"} onClick={() => this.setState({
                                    generatedFile: null
                                }, () => this.generateAgreement(false))}>{"Preview"}</Button>,
                                <Button key={"PDF"} size={"small"} type={"primary"} disabled={this.state.disablePdfGeneration} onClick={() => this.generateAgreement(true)}>GENERATE PDF</Button>
                            ]}
                        >
                            <div
                                key={"file_viewer"}
                                style={{
                                    height: "80vh"
                                }}
                            >
                                {
                                    this.state.generatedFile && (
                                        <DocumentViewer 
                                            fileType={"pdf"}
                                            fileString={this.state.generatedFile}
                                        />
                                    )
                                }
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Form>
        );
    }
}

const FORM_STYLE = {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
};

AgreementForm.propTypes = {
    form: PropTypes.object,
    agreementMasterList: PropTypes.array,
    onSubmit: PropTypes.func,
    companyDetails: PropTypes.object,
    agreementValues: PropTypes.object,
    agreementDetail: PropTypes.object,
    generatePdf: PropTypes.func,
    masterType: PropTypes.object,
    fetchAgreementDetail: PropTypes.object,
    fetchCompanyAgreementDetail: PropTypes.func,
    companyId: PropTypes.number
};

export default Form.create({
    mapPropsToFields: ({agreementValues}) => {
        try {
            const fields = agreementValues && agreementValues["data"];
            if(fields) {
                return new Map(fields)
                    .map((value, key) => {
                        if(key === "Date") {
                            return Form.createFormField({
                                value: value ? moment(value) : value
                            });
                        }
                        if(key === "Processing Fee" || key === "Processing Fees") {
                            let val = value;
                            if(val && String(val).includes("<br>")) {
                                val = String(val).split("<br>").join("\n");
                            }
                            return Form.createFormField({
                                value: val
                            });
                        }
                        if(key === "Fy1 Financials") {
                            return new Map(value)
                                .map((v) => {
                                    return Form.createFormField({
                                        value: v
                                    });
                                }).toJS();
                        }
                        if(key === "Fy2 Financials") {
                            return new Map(value)
                                .map((v) => {
                                    return Form.createFormField({
                                        value: v
                                    });
                                }).toJS();
                        }
                        return Form.createFormField({
                            value: value ? value : null
                        });
                    })
                    .toJS();
            }
        } catch(error) {
            console.error("rerrr => ", error.message);
        }
    }, onFieldsChange: (props, fields) => {
        try {
            const errors = Map(fields).toList().reduce((agg, _) => !!_.errors || agg, false);
            if(
                !errors &&
                (fields.master && !fields.master.validating) 
            ) {
                const values = props.agreementValues && props.agreementValues.data;
                let fieldsObj = props.form.getFieldsValue(["master"]);
                fieldsObj = fieldsObj.master && fieldsObj.master.master_data;
                let list =  fieldsObj && fieldsObj.map(_ => {
                    if(values && values[_.label]) {
                        return {
                            label: _.label,
                            value: values[_.label]
                        };
                    }
                    return {
                        label: _.label,
                        value: props.agreementDetail && props.agreementDetail[_.field]
                    };
                });
                list = list && new List(list)
                    .toMap()
                    .mapEntries(([, v]) => ([v.label, v])).toJS();
                return setTimeout(
                    () =>
                        props.form.setFields(
                            Map({
                                ...list
                            }).map((value, key) => {
                                if(key === "Date") {
                                    return Form.createFormField({
                                        value: value && value.value ? moment(value.value) : null
                                    });
                                }
                                if(key === "Processing Fee" || key === "Processing Fees") {
                                    let val = value && value.value;
                                    if(val && String(val).includes("<br>")) {
                                        val = String(val).split("<br>").join("\n");
                                    }
                                    return Form.createFormField({
                                        value: val
                                    });
                                }
                                if(key === "Fy1 Financials") {
                                    return new Map(value)
                                        .map((v) => {
                                            return Form.createFormField({
                                                value: v
                                            });
                                        }).toJS();
                                }
                                if(key === "Fy2 Financials") {
                                    return new Map(value)
                                        .map((v) => {
                                            return Form.createFormField({
                                                value: v
                                            });
                                        }).toJS();
                                }
                                return Form.createFormField({
                                    value: value.value ? value.value : null
                                });
                            })
                                .toJS()
                        ),
                    300
                );
            }
        } catch(error) {
            console.error(error);
        }
    }
})(AgreementForm);